export const digitcertUrl = '//seal.digicert.com/seals/cascade/seal.min.js';

export function injectDigicert() {
  window.abcd = window.abcd || 0;
  window.__dcid = window.__dcid || [];
  var dcidArr = ["DigiCertClickID_p0PhGTT3", "11", "s", "black", "p0PhGTT3"];
  window.__dcid.push(dcidArr);
  var script = document.createElement('script');
  script.async = true;
  script.src = digitcertUrl;
  document.body.appendChild(script);
};
